import { useState, type FormEvent } from 'react';
import { Link } from 'react-router';
import { ApiError, api } from '../api/client';
import { AuthLayout } from '../components/AuthLayout';
import { Alert, Field } from '../components/ui';

/**
 * «Jeg har glemt passordet.»
 *
 * Skjemaet sier aldri om adressen finnes. Serveren svarer likt uansett, og
 * siden gjentar det svaret – hadde den vist «ingen konto med den adressen»,
 * ville hvem som helst kunne kartlagt hvem som er kunder hos oss.
 */
export function ForgotPasswordPage() {
  const [email, setEmail] = useState('');
  const [sendt, setSendt] = useState(false);
  const [feil, setFeil] = useState<string | null>(null);
  const [jobber, setJobber] = useState(false);

  const onSubmit = async (event: FormEvent) => {
    event.preventDefault();
    setJobber(true);
    setFeil(null);
    try {
      await api.post('/auth/forgot-password', { email });
      setSendt(true);
    } catch (caught) {
      setFeil(caught instanceof ApiError ? caught.message : 'Noe gikk galt. Prøv igjen.');
    } finally {
      setJobber(false);
    }
  };

  if (sendt) {
    return (
      <AuthLayout title="Se i innboksen">
        <Alert kind="success">
          Vi har sendt en lenke til <strong>{email}</strong> hvis adressen hører til en konto.
        </Alert>
        <p className="small muted">
          Lenken virker i én time og kan bare brukes én gang. Finner du den ikke, sjekk søppelpost
          — eller{' '}
          <button type="button" className="lenkeknapp" onClick={() => setSendt(false)}>
            prøv en annen adresse
          </button>
          .
        </p>
        <p className="small">
          <Link to="/logg-inn">Tilbake til innlogging</Link>
        </p>
      </AuthLayout>
    );
  }

  return (
    <AuthLayout
      title="Glemt passord?"
      subtitle="Skriv e-postadressen din, så sender vi en lenke for å velge et nytt."
    >
      <form onSubmit={onSubmit} noValidate>
        <Alert>{feil}</Alert>

        <Field label="E-post">
          <input
            className="input"
            type="email"
            autoComplete="email"
            required
            autoFocus
            value={email}
            onChange={(event) => setEmail(event.target.value)}
          />
        </Field>

        <button className="btn btn-primary btn-block" type="submit" disabled={jobber}>
          {jobber ? 'Sender …' : 'Send lenke'}
        </button>
      </form>

      <p className="small muted" style={{ marginTop: '1rem' }}>
        Kom du på det? <Link to="/logg-inn">Logg inn</Link>
      </p>
    </AuthLayout>
  );
}
